import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { DeliverySchema } from '../types/deliverySchema';
import { getDeliveryDescription } from '../services/GetDeliveryDescription';

const initialState: DeliverySchema = {
  deliveryDescriptionData: null,
  isLoadingData: false,
};

export const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.delivery,
      };
    });
    builder.addCase(getDeliveryDescription.pending, state => {
      state.isLoadingData = true;
    });
    builder.addCase(getDeliveryDescription.fulfilled, (state, action) => {
      if (action.payload) {
        state.deliveryDescriptionData = action.payload;
      }
      state.isLoadingData = false;
    });
    builder.addCase(getDeliveryDescription.rejected, state => {
      state.isLoadingData = false;
    });
  },
});

export const { actions: deliveryActions } = deliverySlice;
